import { Button } from '@mui/material'
import React, { useCallback } from 'react'
import useModals from 'src/Hooks/useModals'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface Props {
  onClick: (companyId: number, token: string) => void
  companyId: number
  token: string
  confirmTitle: string
  confirmText: string
  children?: React.ReactNode
}

/**
 * The ReSendInviteControl triggers a confirmation dialog, before calling the provided actual callback.
 *
 * @param children
 * @param onClick
 * @param companyId
 * @param token
 * @param confirmTitle
 * @param confirmText
 * @constructor
 */
const ReSendInviteControl: React.FC<Props> = ({ children, onClick, companyId, token, confirmTitle, confirmText }) => {
  const { openConfirmationModal } = useModals()
  const { t } = useCustomTranslation()

  const handleClick = useCallback(() => {
    openConfirmationModal({
      onConfirm: onClose => {
        onClick(companyId, token)
        onClose()
      },
      buttonText: [t('common.close'), t('common.send')],
      title: confirmTitle,
      text: confirmText,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onClick, companyId, token])

  return (
    <Button sx={{ whiteSpace: 'nowrap' }} onClick={handleClick}>
      {children}
    </Button>
  )
}

export default ReSendInviteControl
